/* globalmodule */
define( '../src/sublayouts/m40-status-message/m40-status-message',[ 'jquery' ], function ( $ ) {

	'use strict';

	var M40_StatusMessage = function ( $component ) {

		this.$component = $component;

		return this;
	};

	/**
	 * Initialise component
	 */

	M40_StatusMessage.prototype.init = function () {

		this.$component.find( '[ data-print ]' ).on('click', function() {

			if ( window.print ) {
				window.print();
			}

		} );

	};

	return M40_StatusMessage;
} );
